import { Link } from "react-router-dom";

export const PremiumMembershipBanner = () => {
  const benefits = [
    "Spend your points like cash",
    "Unlimited coupon redemptions",
    "Premium-only exclusive deals",
    "Zero in-app ads.",
  ];

  return (
     <section className="relative w-full flex justify-center bg-white overflow-hidden mb-12">

      <div className="w-full max-w-[1700px] py-6 flex flex-col items-center text-center relative">

        {/* LABEL */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-[10px] h-[10px] rounded-full bg-red-600" />
          <span className="text-[20px] text-neutral-700">
            Premium Membership
          </span>
        </div>


        {/* TITLE */}
        <h2 className="text-[72px] leading-[1.1] font-semibold text-neutral-900 mb-6">
          Unlock the Full Experience.
        </h2>


        {/* DESCRIPTION */}
        <p className="max-w-[650px] text-[20px] text-neutral-600 mb-14">
          Upgrade to Premium to turn points into real savings, unlock exclusive
          deals, and enjoy an ad-free experience.
        </p>


        {/* BENEFITS */}
        <div className="flex gap-4 mb-[80px] flex-wrap justify-center items-center px-4">
          {benefits.map((text, i) => (
            <div
              key={i}
              className="
              flex
                justify-center items-center
                
                bg-white
                rounded-full
                shadow-[0px_8px_30px_rgba(0,0,0,0.08)]
                text-[18px]
                text-neutral-800
                px-12
                h-[100px]
                w-[300px]
                text-center
              "
            >
              {text}
            </div>
          ))}
        </div>



        {/* PHONE AREA */}
        <div className="relative flex flex-col items-center">

          {/* BACKGROUND TEXT */}
          <div className="
            absolute
            text-[220px]
            font-semibold
            text-red-600/5
            select-none
            pointer-events-none
            right-[420px]
            top-[40px]
            whitespace-nowrap
            
          ">
            Your 
          </div>
          <div className="
            absolute
            text-[220px]
            font-semibold
            text-red-600/5
            select-none
            pointer-events-none
            left-[420px]
            top-[40px]
            whitespace-nowrap
            
          ">
            Deal
          </div>


          {/* PHONE */}
          <img
            src="/images/Webp/Mobile3.webp"
            className="
              relative
              w-[420px]
              z-10
              
            "
            alt="Phone preview"
          />



          {/* POINTS TEXT */}
          <div className="
            absolute
            bottom-[200px]
            flex flex-col items-center
            z-20 
          ">
            <div className="text-[38px] font-semibold text-neutral-900">
              4,700
            </div>

            <div className="text-neutral-500 text-[18px]">
              Points Available
            </div>
          </div>



          {/* VALUE CARD */}
          <div className="
            absolute
            bottom-[20px]
            bg-gradient-to-r
            from-red-500/10
            to-red-800/10
            border border-red-500/30
            rounded-[28px]
            px-10 py-6
            z-20
            
          ">
            <div className="text-neutral-700 mb-1">
              Value Unlocked
            </div>

            <div className="text-[36px] font-semibold text-red-600 ">
              $47.00
            </div>
          </div>



          {/* FADE */}
          <div className="
            absolute
            bottom-0
            w-full
            h-[220px]
            bg-gradient-to-t
            from-white
            to-transparent
          "/>

        </div>



        {/* CTA TEXT (FIXED LINE BREAK LIKE FIGMA) */}
        <p className="mt-[80px] text-[20px] text-neutral-700 leading-relaxed max-w-[600px]">
          For just{" "}
          <span className="text-red-600 font-semibold">$12/year</span>, unlock your points and get even
          <br />
          more value!.
        </p>



        {/* BUTTON */}
        <Link
          to="/customer-login"
          className="mt-8 inline-flex items-center justify-center bg-neutral-900 text-white text-[18px] font-medium px-10 py-4 rounded-full hover:opacity-90 transition-opacity"
        >
          Upgrade to Premium
        </Link>

      </div>



      {/* ANIMATIONS */}
      <style>
        {`

        @keyframes appear {
        from {
          opacity: 0;
          clip-path: inset(100% 100% 0 0);
        }
        to {
          opacity: 1;
          clip-path: inset(0 0 0 0);
        }
      }

      .block {
        animation: appear linear;
        animation-timeline: view();
        animation-range: entry 0% cover 40%;
      }

        @keyframes floatPhone {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-14px); }
        }

        @keyframes floatCard {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @keyframes floatSlow {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-25px); }
        }
        `}
      </style>

    </section>
    
  );
};